var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25736 16.7778C1.64785 17.1683 2.28073 17.1686 2.67157 16.7778L9.74264 9.70669C10.1335 9.31585 10.1331 8.68298 9.74264 8.29248L2.67157 1.22141C2.41789 0.967727 2.0614 0.879166 1.73503 0.956074C1.55998 0.99647 1.39408 1.08469 1.25736 1.22141C0.866515 1.61225 0.866861 2.24513 1.25736 2.63563L7.62132 8.99959L1.25736 15.3635C0.866515 15.7544 0.866861 16.3873 1.25736 16.7778Z",
    fill: "#586A84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrowNext.25b4b2d798b9949d170ed531c1b75a40.svg";
export { ForwardRef as ReactComponent };